
export default function Features() {
  const features = [
    {
      icon: 'ri-refresh-line',
      title: '定期・会計監査を含む様々な場面でリース不要のレンタルサービス',
      description: '柔軟な契約形態で、必要な期間だけご利用いただけます。'
    },
    {
      icon: 'ri-group-line',
      title: '人気店舗数が少ない場合でも対応カウンター料金なしで無制限',
      description: 'カウンター料金を気にせず、思う存分印刷できます。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '1営業日以内に無償対応企業様のオフィスに何度も訪問可能',
      description: '迅速なサポート体制で、業務の中断を最小限に抑えます。'
    },
    {
      icon: 'ri-truck-line',
      title: '印刷しなくても無料修理日数が経過しても無料で配送いたします',
      description: '使用頻度に関わらず、安心の定額制です。'
    },
    {
      icon: 'ri-customer-service-line',
      title: '24時間以内の迅速サポート地域密着型の細やかな対応で安心',
      description: '専属のサポートチームが、いつでもお客様をサポートします。'
    },
    {
      icon: 'ri-printer-line',
      title: 'インクトナー、大容量印刷でも定額料金で無制限に印刷可能です',
      description: 'トナー代を気にせず、大量印刷も安心です。'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            印刷枚数やご利用目的に合わせた
          </h2>
          <p className="text-3xl md:text-4xl font-bold text-blue-600">
            選べる豊富な機種とプラン
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 leading-tight">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-8">
            スリホは導入社数5,000社以上、業界シェアNo.1<br />
            定額制のプリンターレンタルサービスです。
          </p>
        </div>
      </div>
    </section>
  );
}
